
import BaseImage from '@/ui-kit/components/image';
import CarouselItem from '@/ui-kit/components/carousel-item';
import Carousel from '@/ui-kit/components/carousel';
import { CarouselPropsEventType, CarouselSlotName } from '@/ui-kit/components/carousel/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { GalleryEvent, ImageGallerySlotName } from './enums';

export default {
  name: 'ImageGallery',
  components: {
    Carousel,
    CarouselItem,
    BaseImage,
  },
  props: {
    images: {
      type: Array,
      default: () => ([]),
    },
    imageClassName: {
      type: String,
      default: '',
    },
    height: {
      default: 0,
      type: Number,
    },
    colorScheme: {
      default: StyleColorSchemeType.Secondary,
      type: String,
    },
    hasPagination: {
      default: false,
      type: Boolean,
    },
    initialSlide: {
      default: 0,
      type: Number,
    },
    pagination: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      CarouselSlotName,
      ImageGallerySlotName,
    };
  },
  computed: {
    fullImageClassName() {
      return `image-gallery__item-image ${this.imageClassName}`;
    },
  },
  methods: {
    handleActiveIndexChange(index) {
      this.$emit(CarouselPropsEventType.ActiveIndexChange, index);
    },
    handleImageClick() {
      this.$emit(GalleryEvent.ImageClick);
    },
  },
};
